import { render } from "./TransactionUser.vue?vue&type=template&id=955fe554&scoped=true"
import script from "./TransactionUser.vue?vue&type=script&lang=js"
export * from "./TransactionUser.vue?vue&type=script&lang=js"

import "./TransactionUser.vue?vue&type=style&index=0&id=955fe554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-955fe554"]])

export default __exports__